
<template>
  <n-card
    clickable-shadow
    class="space-selector-btn"
    :class="{ mini, active }"
    @click="goToSpace"
  >
    <template v-if="mini">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <div class="space-logo-wrapper" v-on="on" v-if="logo">
            <div
              class="space-logo"
              :style="`background-image: url('${logo}');`"
            >
              &nbsp;
            </div>
          </div>
          <v-row no-gutters justify="center" align="center" v-on="on" v-else>
            {{ space.name | clientInitials(3) }}
          </v-row>
        </template>
        <div>{{ space.name }}</div>
      </v-tooltip>
    </template>
    <v-row no-gutters justify="center" align="center" style="min-width: 0;" v-else>
      <div class="space-logo-wrapper" v-if="logo">
        <div
          class="space-logo"
          :style="`background-image: url('${logo}');`"
        >
          &nbsp;
        </div>
      </div>
      <v-row no-gutters justify="center" align="center" class="space-initials" v-else>
        {{ space.name | clientInitials(3) }}
      </v-row>
      <v-col class="px-3" style="overflow: hidden;">
        <div class="font-weight-medium ellipsis">
          {{ space.name }}
        </div>
        <div class="text-caption">
          {{ space.slugUrl }}
        </div>
      </v-col>
      <v-icon>chevron_right</v-icon>
    </v-row>
  </n-card>
</template>

<script>
export default {
  props: {
    space: {
      type: Object,
      required: true,
    },
    mini: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    logo() {
      return this.$clientLogoUrl(this.space);
    },
    ssoUrl() {
      let ssoUrl = `${this.space.slugUrl}/sso?token=${this.space.ssoToken}&logout=0`;

      if (ssoUrl.indexOf(`http:`) !== 0) {
        const protocol = window.location.protocol; // eslint-disable-line
        ssoUrl = `${protocol}//${ssoUrl}`;
      }

      return ssoUrl;
    },
    active() {
      return window.location.host === this.space.slugUrl;
    },
  },

  methods: {
    goToSpace() {
      window.location.href = this.ssoUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.space-selector-btn {
  min-height: 80px;
  display: flex;
  padding-left: 16px !important;
  padding-right: 16px !important;
  img {
    max-height: 55px;
    max-width: 100px;
  }
  .space-initials {
    height: 55px;
    min-height: 55px;
    max-height: 55px;
    width: 55px;
    max-width: 55px;
    border: 1px solid #AAA;
    border-radius: 6px;
  }
  &.mini {
    height: 55px;
    min-height: 55px;
    max-height: 55px;
    width: 55px;
    max-width: 55px;
    padding: 6px !important;
    .space-logo-wrapper {
      width: 100%;
      height: 100%;
    }
    &.active {
      border: 3px solid $primaryColor;
    }
  }

  &:not(.mini) {
    .space-logo-wrapper {
      height: 55px;
      min-height: 55px;
      max-height: 55px;
      width: 55px;
      max-width: 55px;
    }
  }
  .space-logo-wrapper {
    .space-logo {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-position: center;
    }
  }
}
</style>
